var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _this = this;
// See https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var patchPrototype = function (instance, target) {
    var proto = target.prototype;
    if (Object.setPrototypeOf) {
        Object.setPrototypeOf(instance, proto);
    }
    else {
        _this.__proto__ = proto; // eslint-disable-line no-proto
    }
};
/**
 * The base type for all Gedcom related errors. All errors are currently also instances of {@link ErrorParse}.
 */
var ErrorGedcomBase = /** @class */ (function (_super) {
    __extends(ErrorGedcomBase, _super);
    function ErrorGedcomBase(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorGedcomBase;
}(Error));
export { ErrorGedcomBase };
var ErrorParse = /** @class */ (function (_super) {
    __extends(ErrorParse, _super);
    function ErrorParse(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorParse;
}(ErrorGedcomBase));
export { ErrorParse };
var ErrorInvalidFileType = /** @class */ (function (_super) {
    __extends(ErrorInvalidFileType, _super);
    function ErrorInvalidFileType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ErrorInvalidFileType;
}(ErrorParse));
export { ErrorInvalidFileType };
var ErrorGedcomDecoding = /** @class */ (function (_super) {
    __extends(ErrorGedcomDecoding, _super);
    function ErrorGedcomDecoding(message, illegalCode) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.illegalCode = illegalCode;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorGedcomDecoding;
}(ErrorParse));
export { ErrorGedcomDecoding };
var ErrorUnsupportedCharset = /** @class */ (function (_super) {
    __extends(ErrorUnsupportedCharset, _super);
    function ErrorUnsupportedCharset(message, charset) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.charset = charset;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorUnsupportedCharset;
}(ErrorParse));
export { ErrorUnsupportedCharset };
var ErrorTokenization = /** @class */ (function (_super) {
    __extends(ErrorTokenization, _super);
    function ErrorTokenization(message, lineNumber, line) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.lineNumber = lineNumber;
        _this.line = line;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorTokenization;
}(ErrorParse));
export { ErrorTokenization };
var ErrorTreeSyntax = /** @class */ (function (_super) {
    __extends(ErrorTreeSyntax, _super);
    function ErrorTreeSyntax(message, lineNumber) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.lineNumber = lineNumber;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorTreeSyntax;
}(ErrorParse));
export { ErrorTreeSyntax };
var ErrorInvalidNesting = /** @class */ (function (_super) {
    __extends(ErrorInvalidNesting, _super);
    function ErrorInvalidNesting(message, lineNumber, currentLevel, level) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, lineNumber) || this;
        _this.lineNumber = lineNumber;
        _this.currentLevel = currentLevel;
        _this.level = level;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorInvalidNesting;
}(ErrorTreeSyntax));
export { ErrorInvalidNesting };
var ErrorInvalidConcatenation = /** @class */ (function (_super) {
    __extends(ErrorInvalidConcatenation, _super);
    function ErrorInvalidConcatenation(message, lineNumber, kind) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, lineNumber) || this;
        _this.lineNumber = lineNumber;
        _this.kind = kind;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorInvalidConcatenation;
}(ErrorTreeSyntax));
export { ErrorInvalidConcatenation };
var ErrorInvalidRecordDefinition = /** @class */ (function (_super) {
    __extends(ErrorInvalidRecordDefinition, _super);
    function ErrorInvalidRecordDefinition(message, lineNumber) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, lineNumber) || this;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorInvalidRecordDefinition;
}(ErrorTreeSyntax));
export { ErrorInvalidRecordDefinition };
var ErrorTreeStructure = /** @class */ (function (_super) {
    __extends(ErrorTreeStructure, _super);
    function ErrorTreeStructure(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorTreeStructure;
}(ErrorParse));
export { ErrorTreeStructure };
var ErrorEmptyTree = /** @class */ (function (_super) {
    __extends(ErrorEmptyTree, _super);
    function ErrorEmptyTree(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorEmptyTree;
}(ErrorTreeStructure));
export { ErrorEmptyTree };
var ErrorIndexing = /** @class */ (function (_super) {
    __extends(ErrorIndexing, _super);
    function ErrorIndexing(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorIndexing;
}(ErrorParse));
export { ErrorIndexing };
var ErrorDuplicatePointer = /** @class */ (function (_super) {
    __extends(ErrorDuplicatePointer, _super);
    function ErrorDuplicatePointer(message, lineNumber, lineNumberOriginalDefinition, pointer) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.lineNumber = lineNumber;
        _this.lineNumberOriginalDefinition = lineNumberOriginalDefinition;
        _this.pointer = pointer;
        patchPrototype(_this, _newTarget);
        return _this;
    }
    return ErrorDuplicatePointer;
}(ErrorIndexing));
export { ErrorDuplicatePointer };
//# sourceMappingURL=error.js.map